import {useForm, useWatch} from "react-hook-form";
import {CHECKBOX_TYPE} from "v4/data/fieldTypes";
import {useEffect, useMemo} from "react";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";

export default function useMapImportColumnFieldsConcatenationField(fieldToUpdate) {
    const {formRenderMethods, getField} = useFormRenderContext();
    const methods = useForm();

    const [fieldToListenValue, fieldToUpdateValue] = useWatch({
        name: [fieldToUpdate?.name.replace('_action', ''), fieldToUpdate?.name],
    });

    useEffect(() => {
        if (!fieldToUpdateValue?.endsWith('id')) return;

        methods.setValue('concatenationField', false);
    }, [fieldToUpdateValue, methods]);

    const form = useMemo(() => {
        if (!fieldToListenValue?.length) return null;

        const isConcatenable = getField(fieldToUpdate?.name.replace('_action', ''))?.choices
            ?.find(choice => choice.value === fieldToListenValue)
            ?.attr?.['data-is-concatenable'] === 'true';

        if (!isConcatenable || fieldToUpdateValue?.endsWith('id')) return null;

        return {
            results: {
                concatenationField: {
                    type: CHECKBOX_TYPE,
                    label: 'import_concat_instead_of_replace',
                    value: false,
                    onFieldChange: (value) => {
                        formRenderMethods.setValue(fieldToUpdate.name, value ? 'add' : 'update');
                    }
                }
            }
        }
    }, [fieldToListenValue, fieldToUpdateValue, fieldToUpdate, formRenderMethods, getField]);

    return {
        form,
        methods,
    }
}
